/**
 * 写法四格(BPWB-2,2026-09-03):全片结构 / 情绪基调 / 开头手法 / 结尾手法,
 * 2×2 小格,进蓝图工作卡(`BlueprintHeroCard`)的 structure 插槽。
 *
 * 缺哪格不渲哪格(老蓝图可能没有拆解报告,只剩蓝图自带的 cta);开头/结尾两格给的是
 * 参考片原话(仅作手法例子,不是内容红线要挡的东西),带一行小字提醒「参考原话,只看手法」——
 * 别让用户误以为这句话可以直接抄。
 */
import type { ReporterBlueprintCraft } from "@/entities/scene-card/model/presets";

const CELLS: { key: keyof ReporterBlueprintCraft; label: string; withNote: boolean }[] = [
  { key: "structure", label: "全片结构", withNote: false },
  { key: "emotion", label: "情绪基调", withNote: false },
  { key: "hookExample", label: "开头手法", withNote: true },
  { key: "ctaExample", label: "结尾手法", withNote: true },
];

export function BlueprintCraftGrid({ craft }: { craft: ReporterBlueprintCraft }) {
  const cells = CELLS.filter((c) => craft[c.key]);
  if (!cells.length) return null;

  return (
    <div className="grid grid-cols-1 gap-1.5 sm:grid-cols-2" data-testid="blueprint-craft-grid">
      {cells.map((c) => (
        <div
          key={c.key}
          className="rounded-md border border-border/60 bg-background/60 px-2.5 py-1.5 text-2xs leading-relaxed text-muted-foreground"
        >
          <b className="block font-mono text-[10px] font-semibold tracking-wide text-primary/80">
            {c.label}
          </b>
          <span>{craft[c.key]}</span>
          {c.withNote && (
            <span className="ml-1.5 text-[10px] text-muted-foreground/60">(参考原话,只看手法)</span>
          )}
        </div>
      ))}
    </div>
  );
}
